import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment } from '@mui/material';
import { useState } from 'react';

import { GridSizeType, gridSize } from '@/shared/constants/ui.constants';
import CustomTextField from './CustomTextField';

export type CustomPasswordTextFieldProps = {
  label: string;
  name: string;
  form: any;
  errors: any;
  size?: GridSizeType;
  disabled?: boolean;
  required?: boolean;

  //send with enter
  enableToSubmitWithEnter?:boolean;
  handleSubmit?: () => void;
};

const CustomPasswordTextField: React.FC<CustomPasswordTextFieldProps> = ({
  label,
  name,
  form,
  errors,
  size = gridSize,
  disabled = false,
  required = true,

  //send with enter
  enableToSubmitWithEnter = false,
  handleSubmit = () => console.log("nothing happen")
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };


  return (
      <CustomTextField
        label={label}
        name={name}
        overrideAsPassword // avoid uppercase in text mode
        control={form.control}
        defaultValue={form.getValues(name) || form.getValues().password}
        error={errors[name]}
        helperText={errors[name]?.message}
        type={showPassword ? 'text' : 'password'}
        endAdornmentInput={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        size={size}
        disabled={disabled}
        required={required}

        enableToSubmitWithEnter={enableToSubmitWithEnter}
        handleSubmit={handleSubmit}
      />
  );
};

export default CustomPasswordTextField;
